export default __webpack_public_path__ + "img/969f6b7ce660a6d6b1f1939c41efd533.svg";